import { formatDate, toCalendarDate, type DateInput } from "@/lib/dates";

export interface FormattedDateProps {
  date: DateInput;
  /** Abbreviated month ("Feb 24, 2026") for tight spots such as cards, tags, and navigation. */
  compact?: boolean;
  className?: string;
}

/** Displays a content date in the site-wide format, machine-readable via `<time datetime>`. */
export function FormattedDate({ date, compact = false, className }: FormattedDateProps) {
  return (
    <time dateTime={toCalendarDate(date)} className={className}>
      {formatDate(date, { compact })}
    </time>
  );
}
